import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../images/logo-trns.png";
import menuIcon from "../images/menuIcon.png";

function Navbar() {
  const [click, setClick] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(null);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  useEffect(() => {
    const handleResize = () => setShowButton(window.innerWidth > 960);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const pathMap = {
      "/": 0,
      "/dashboard": 1,
      "/algoTurtle-ai": 2,
      "/pricing": 3,
      "/blogs": 4,
      "/about-us": 5,
      "/login": 6,
    };
    setActiveItem(pathMap[location.pathname] ?? null);
  }, [location.pathname]);

  const menuItems = [
    { name: "Home", path: "/" },
    { name: "Dashboard", path: "/dashboard" },
    { name: "Ai Graph", path: "/algoTurtle-ai" },
    { name: "Pricing", path: "/pricing" },
    { name: "Blogs", path: "/blogs" },
    { name: "About us", path: "/about-us" },
    { name: "Login", path: "/login" },
  ];

  return (
    <nav
      className={`w-full fixed top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-white shadow-md" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-20">
        {/* Logo and Title */}
        <div className="flex items-center gap-2">
          <Link to="/">
            <img src={logo} alt="Logo" className="w-14 h-14" />
          </Link>
          <Link to="/" className="text-2xl font-bold whitespace-nowrap">
            <span className="text-[#2D3192]">algo</span>
            <span className="text-green-700">Turtle</span>
          </Link>
        </div>

        {/* Menu Toggle Icon (Mobile) */}
        <div className="md:hidden cursor-pointer" onClick={handleClick}>
          <img src={menuIcon} alt="Menu" className="w-8 h-8" />
        </div>

        {/* Nav Items */}
        <ul
          className={`${
            click ? "flex" : "hidden"
          } md:flex flex-col md:flex-row absolute md:relative top-20 md:top-0 left-0 w-full md:w-auto bg-white md:bg-transparent md:space-x-6 shadow-md md:shadow-none rounded-b-lg md:rounded-none px-4 md:px-0 pb-4 md:pb-0 z-40 transition-all duration-300 ease-in-out`}
        >
          {menuItems.map((item, idx) => (
            <li key={item.path} className="text-center">
              <Link
                to={item.path}
                onClick={closeMobileMenu}
                className={`block py-2 md:py-1 px-4 rounded-full text-base font-medium hover:bg-[#2D3192] hover:text-white transition ${
                  activeItem === idx ? "bg-[#2D3192] text-white" : "text-black"
                }`}
              >
                {item.name}
              </Link>
            </li>
          ))}

          {/* Mobile CTA */}
          <li className="md:hidden mt-2">
            <Link
              to="/register"
              onClick={closeMobileMenu}
              className="block text-center w-full border border-black px-4 py-2 rounded-full text-base font-medium hover:bg-[#2D3192] hover:text-white transition"
            >
              Build strategy
            </Link>
          </li>
        </ul>

        {/* Desktop CTA */}
        {showButton && (
          <Link
            to="/register"
            className="hidden md:inline-block bg-green-700 hover:bg-[#2d3191] text-white font-semibold py-2 px-6 rounded-full transition"
          >
            Build strategy
          </Link>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
